import { useSelector } from 'react-redux'
import { getScreenIsReady } from 'selectors/screen'
import { isSessionSet, getUserID } from 'selectors/user/session'
import { getAlgoliaUserToken } from 'selectors/user/cookie'

type UseCollectionPolaroidListResponse = {
  isLoading: boolean
  algoliaUserToken: string
  userID: number
}

const useCollectionPolaroidList = (): UseCollectionPolaroidListResponse => {
  const isScreenReady = useSelector(getScreenIsReady)
  const isSet = useSelector(isSessionSet)
  const isLoading = !isScreenReady || !isSet

  const algoliaUserToken = useSelector(getAlgoliaUserToken)
  const userID = useSelector(getUserID)

  return { isLoading, algoliaUserToken, userID }
}

export default useCollectionPolaroidList
